/**
 * 对象容器
 * 将公用对象都挂载到此容器中，方便调用
 */
export default {
	lastModel: 1,
	beforeCropModel: '',
	noMember(){
        $('.banner_box>#drag-zone').removeClass('active');
        $('.banner_box>.info_log').show();
        $('.header .right>.login>span').show()
        $('.photo_upgrade').removeClass('active');

        $('.login_box').hide();
        $('.login_btn>a').show();
        $('.photo_toggle_box>div span').removeClass('no');
        setCookie("user","",-1)
        user="";
    },
    LoginSuccess(){
        user=getCookie('user')
        if(user){
            user=JSON.parse(user)
            $.post(
                post_url+"product/trial",
                {
                    e_id:user.e_id,
                    t_id:user.t_id,
                    token:user.token,
                    p_id:this.product_id
                },
                function(data){
                }
            )
        }else{
            this.noMember();
        }
    },
    benefitStatus(successCallback,errorCallback){
        var parameter;
        if(user){
            parameter={
                e_id:user.e_id,
                t_id:user.t_id,
                token:user.token,
                product_id:this.product_id
            }
        }else{
            parameter={
                e_id:murmur,
                product_id:this.product_id
            }
        }
        var that=this
        $.post(
            post_url+'benefit/status',
            parameter,
            function(data){
                if(data.error==0){
                    console.log(data)
                    that.subscriptions={
                        credit:{
                            quota:0,
                            cost:0,
                            threshold:0,
                        },
                        in_size:{
                            limit:0,
                            threshold:0,
                            quota:0,
                            usage:0,
                        },
                        in_edge:{
                            limit:0,
                            threshold:0,
                            quota:0,
                            usage:0,
                        },
                        enhancer:{
                            quota:0
                        }
                    }
                    for(var i=0;i<data.subscriptions.length;i++){
                        if(![0,-1].includes(data.subscriptions[i].product_feature*1)){
                            that.subscriptions.enhancer.quota++
                        }
                        for(var j=0;j<data.subscriptions[i].benefits.length;j++){
                            var obj=data.subscriptions[i].benefits[j]
                            switch(obj.key){
                                case 'credit':
                                    that.subscriptions.credit.quota+=obj.quota*1
                                    that.subscriptions.credit.cost+=obj.cost*1
                                    break;
                                case 'watermark.out_edge':
                                    that.subscriptions.credit.quota+=obj.quota*1
                                    that.subscriptions.credit.cost+=obj.cost*1
                                    that.subscriptions.credit.threshold=obj.threshold*1
                                    break;
                                case 'watermark.in_size':
                                    if(obj.limit*1>=that.subscriptions.in_size.limit*1){
                                        that.subscriptions.in_size.limit=obj.limit*1
                                    }
                                    if(obj.threshold*1>=that.subscriptions.in_size.threshold*1){
                                        that.subscriptions.in_size.threshold=obj.threshold*1
                                    }
                                    if(that.subscriptions.in_size.quota!=-1){
                                        that.subscriptions.in_size.quota+=obj.quota*1
                                        that.subscriptions.in_size.usage+=obj.usage*1
                                    }
                                    if(obj.quota*1==-1){
                                        that.subscriptions.in_size.quota=-1
                                    }
                                    break;
                                case 'watermark.in_edge':
                                    if(obj.limit*1>=that.subscriptions.in_edge.limit*1){
                                        that.subscriptions.in_edge.limit=obj.limit*1
                                    }
                                    if(obj.threshold*1>=that.subscriptions.in_edge.threshold*1){
                                        that.subscriptions.in_edge.threshold=obj.threshold*1
                                    }
                                    if(that.subscriptions.in_edge.quota!=-1){
                                        that.subscriptions.in_edge.quota+=obj.quota*1
                                        that.subscriptions.in_edge.usage+=obj.usage*1
                                    }
                                    if(obj.quota*1==-1){
                                        that.subscriptions.in_edge.quota=-1
                                    }
                                    break;
    
                            }
                        }
                    }
                    console.log(that.subscriptions,133)
                    successCallback()
                }else{
                    try{
                        errorCallback()
                    }catch(e){}
                    error(i18nWaterMark.global.t('error_268'+data.error));
                }
            }
        ).fail(function(){
                $('.edit_box .load').hide();
                $('.edit_box>.uploadBox').show();
                overtime(26899);
        })
    },
    visitor2Login:'',
    downJson:'',
    manage(operation,data){
        // _gaq.push(['_trackEvent','Watermark Remover',operation,String(data)]);
    },
    brush_model:[],
    brush_size:[],
    subscriptions:null,
    original:0,
    token:'',
    // 0首次进入
    first:0,
    product_id:1049
}